import { EntityTypes } from './enums/entityTypes';

export interface AssessmentSubmission {
  submissionId: string;
  assessmentRecordId: string;
  orgId: string;
  userId: string;
  entityType: EntityTypes.assessmentSubmission;
  sectionStatus: SubmissionSectionStatus;
  completed?: boolean;
  answers: SubmissionAnswerHolder;
  created: number;
  lastUpdated: number;
}

export interface SubmissionAnswerHolder {
  [key: string]: SubmissionAnswerSection;
}

export interface SubmissionAnswerSection {
  [key: string]: SubmissionAnswer;
}

export interface SubmissionAnswer {
  id: number;
  subSection: string;
  answer: string;
  answered: boolean;
  files?: SubmissionFile[];
  question?: string;
}

export interface SubmissionSectionStatus {
  [key: string]: boolean;
}

export interface SubmissionFile {
  fileName: string;
  key: string;
}
